import React from "react";
import ASingleLambdaTestLive from "./aSingleLambdaTestLive";

const ResultsCounts = ({ show, assessmentInformation, resultsCounts, testsMap }) => {    
    return (
        <>
            {
                testsMap && show && (
                    <div className="lambda-results-container" style={{ marginTop: "0px", width: "100%", rowGap: "10px" }}>
                        {
                            !assessmentInformation.pollMode && (
                                <div>
                                    <span className="required">*</span> The test results below will update live in poll mode only
                                </div>
                            )
                        }                       
                        {
                            Object.keys(testsMap).map((testUuid) => {
                                if (resultsCounts && testUuid in resultsCounts) {
                                    return <ASingleLambdaTestLive key={testUuid} count={resultsCounts[testUuid]} name={testsMap[testUuid]?.testName}/>
                                } else {
                                    return <ASingleLambdaTestLive key={testUuid} count={0} name={testsMap[testUuid]?.testName}/>
                                }
                            })
                        }
                    </div>
                )
            }
        </>
    );
}

export default ResultsCounts;